
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.212 1.027H6.796a3.26 3.26 0 00-1.916.622L2.926 3.07A3.26 3.26 0 001.74 4.7L.995 6.996a3.26 3.26 0 000 2.016l.746 2.297a3.26 3.26 0 001.185 1.63l1.954 1.42a3.26 3.26 0 001.916.622h2.416a3.26 3.26 0 001.916-.622l1.954-1.42a3.26 3.26 0 001.185-1.63l.746-2.297a3.26 3.26 0 000-2.016L14.267 4.7a3.26 3.26 0 00-1.185-1.63l-1.954-1.42a3.26 3.26 0 00-1.916-.622z","fill":"url(#paint0_radial_8563_29863)","stroke":"#4A2D00","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.915 5.733a.093.093 0 11-.093-.092M9.618 4.993a.093.093 0 11-.092-.093M11.1 7.956a.093.093 0 11-.093-.093M8.137 7.956a.093.093 0 11-.093-.093M5.174 9.437a.093.093 0 11-.093-.093M8.878 10.918a.093.093 0 11-.093-.092","stroke":"#221600","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_8563_29863","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"matrix(0 5.2219 -5.36505 0 8.004 8.337)"}},[_c('stop',{attrs:{"offset":".432","stop-color":"#FFD178"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFAC0B"}})])])])
          )
        }
      }
    